import { defer } from 'react-router-dom'
import { isAppStateReady } from 'src/state/store'
import { logger } from '$utils'
import useStockStore from '../../store'
import { initialState as initialInvoiceHistoryState } from './slice'
import { parseSortModelToParamString } from 'src/components/common/helpers'

export default async function invoiceHistoryLoader() {
  logger.debug(
    '[loader] About to await AppState being ready in Invoice History loader'
  )
  await isAppStateReady()
  logger.debug(
    '[loader] AppState should now be ready in Invoice History loader'
  )

  useStockStore.getState().resetInvoiceHistorySlice()

  const getInvoices = useStockStore.getState().getInvoices({
    start: initialInvoiceHistoryState.invoiceHistoryFilters.from,
    end: initialInvoiceHistoryState.invoiceHistoryFilters.to,
    status: initialInvoiceHistoryState.invoiceHistoryFilters.status,
    page: useStockStore.getState().paginationModel.page,
    pageSize: useStockStore.getState().paginationModel.pageSize,
    sort: parseSortModelToParamString(useStockStore.getState().sortModel),
  })
  const getSuppliers = useStockStore.getState().getSuppliers()

  return defer({
    data: Promise.all([getInvoices, getSuppliers])
      .then(() => true)
      .catch((error) => {
        logger.error('Invoice History Promise.all error', error)
        return false
      }),
  })
}
